import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import App from "./features/app/App";
import getStore from "./features/app/store";
import * as buffer from "buffer";
import "./util/crypto-polyfill";
import Footer from "./components/footer";
import { CSSProperties } from "react";
import { defineModule } from "@amzn/awt-module-api";
import { ModuleContextProvider } from "@amzn/awt-module-react-utils";
import { createModulesRuntime, definePlugin } from "@amzn/awt-modules-runtime";
import { importPackage } from "@amzn/loom-lotus-import-package";
import { getLoomAgentWidgetPackageName } from "./constants/common";
import { MODULE_ID as AGENT_MODULE_ID } from "@amzn/loom-agent-assistance-widget-api";

const footerWrapperStyle: CSSProperties = {
  position: "sticky",
  bottom: "0",
  width: "100%",
  height: "83px",
  zIndex: 4999,
};

if (typeof window !== "undefined") {
  window.Buffer = buffer.Buffer;
  window.global = window;
}

const module = defineModule({
  activate: (moduleContext) => {
    ReactDOM.render(
      <>
        <ModuleContextProvider value={moduleContext}>
          <Provider store={getStore()}>
            <App />
          </Provider>
        </ModuleContextProvider>
        <div id="footer" style={footerWrapperStyle}>
          <Footer />
        </div>
      </>,
      document.getElementById("root")
    );
  },
});

const lotusModuleLoader = (packageName: string, majorVersion: string) => {
  return async () => {
    const result = await importPackage({
      packageName,
      majorVersion,
    });

    if (!result.succeeded) {
      console.error(
        `Failed to import package: ${packageName}@${majorVersion}`,
        result.error?.code,
        result.error?.message
      );
    }

    return result.packageExports?.module;
  };
};

const modules = {
  "dacw-main": {
    loader: async () => module,
    metadata: {
      moduleId: "dacw-main",
      moduleVersion: "1.0.0",
    },
  },
  [AGENT_MODULE_ID]: {
    loader: lotusModuleLoader(getLoomAgentWidgetPackageName(), "1"),
    metadata: {
      moduleId: AGENT_MODULE_ID,
      moduleVersion: "1.0.0",
    },
  },
};

const moduleResolverPlugin = definePlugin({
  pluginId: "resolver",
  activate: (pluginContext) => {
    pluginContext.addModuleResolverStrategy({
      discoverModuleByModuleId: async (moduleId) => {
        return modules[moduleId];
      },
      discoverModulesWithContributions: async (contributionPointId) => {
        return [];
      },
    });
  },
});

const modulesRuntime = createModulesRuntime({
  plugins: [moduleResolverPlugin],
  locale: {
    localeId: "en",
    language: "en",
  },
});

const renderApp = () => {
  modulesRuntime.sendMessage({
    to: "dacw-main",
    type: "dacw-main/initialize",
    payload: {},
  });
};

if (window.loom && window.loom.loaded) {
  renderApp();
} else {
  const elem = document.getElementById("mosaic-navigation");
  const handleLoadEvent = () => {
    renderApp();
    elem?.removeEventListener("mosaic.loaded", handleLoadEvent);
  };
  elem?.addEventListener("mosaic.loaded", handleLoadEvent);
}
